module.exports = __webpack_public_path__ + "a1c41d04acf9f33457fb5303cd0b89e7.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/url-loader?limit=1!./src/assets/icons/firefox_app_icon.png
// module id = 1464
// module chunks = 1